/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetFleetsFleetIdWingsNotFound
 */
export interface GetFleetsFleetIdWingsNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetFleetsFleetIdWingsNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetFleetsFleetIdWingsNotFound interface.
 */
export function instanceOfGetFleetsFleetIdWingsNotFound(value: object): value is GetFleetsFleetIdWingsNotFound {
    return true;
}

export function GetFleetsFleetIdWingsNotFoundFromJSON(json: any): GetFleetsFleetIdWingsNotFound {
    return GetFleetsFleetIdWingsNotFoundFromJSONTyped(json, false);
}

export function GetFleetsFleetIdWingsNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFleetsFleetIdWingsNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetFleetsFleetIdWingsNotFoundToJSON(json: any): GetFleetsFleetIdWingsNotFound {
    return GetFleetsFleetIdWingsNotFoundToJSONTyped(json, false);
}

export function GetFleetsFleetIdWingsNotFoundToJSONTyped(value?: GetFleetsFleetIdWingsNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

